import { Controller } from 'stimulus'
import { handleSubmitForm } from 'shared/assets/javascript/contact_form_7'

export default class extends Controller {

  connect() {
    this.container = document.querySelector('.js-eventInquiryModal')
    this.submitBtn = this.container.querySelector('.js-submit-form')
    this.formContainer = this.container.querySelector('.js-form-container')
    this.formTarget = this.container.querySelector('form')
    this.successContainer = this.container.querySelector('.js-success-container')
    this.closeBtn = document.querySelector('.js-eventInquiryModal .js-modal-close')
    this.toggle = document.querySelectorAll('.js-events-inquiry-toggle')
    this.inquiryModal = document.querySelector('.js-eventInquiryModal')
    this.date = this.container.querySelector('.js-date')
    this.toggle.forEach((el) => {
      el.addEventListener('click', this.openForm.bind(this))
    })
    this.closeBtn.addEventListener('click', this.closeForm.bind(this))
    this.submitBtn.addEventListener('click', this.submitForm.bind(this))
    this.date?.addEventListener('blur', this.onDateBlur.bind(this))
  }

  openForm(e) {
    e.preventDefault()
    this.inquiryModal.classList.add('active')
    document.body.classList.add('-is-open-modal')
  }

  closeForm(e) {
    e.preventDefault()
    this.inquiryModal.classList.remove('active')
    document.body.classList.remove('-is-open-modal')
  }

  async submitForm(e){
    e.preventDefault()
    if (!this.submitBtn) return;
    // Disable button and change text
    this.submitBtn.disabled = true
    const originalText = this.submitBtn.textContent
    this.submitBtn.textContent = 'Submitting...'

    let response = await handleSubmitForm(this.formTarget)

    // Re-enable button and restore text
    this.submitBtn.disabled = false
    this.submitBtn.textContent = originalText

    if (!response) return
    if (response.status === 'mail_sent') {
      this.successContainer.classList.remove('-hidden')
      this.successContainer.classList.add('-show')
      this.formContainer.classList.add('-hide')
      this.container.classList.add('-success')
    } else {
      console.log('error')
      console.log({response})
    }
  }

  onDateBlur(e) {
    if (e.target.validity.valid) return;

    this.date.value = null;
  }
}
